<template>
    <main class="relative h-full font-roboto  overflow-hidden">
        <img src="../../assets/images/login_bg.jpg" alt="" class="w-full h-screen object-cover mobile:scale-[1.5] tablet:scale-[1.4] laptop:scale-100">
        <div class="absolute mobile:w-full largeDesktop:w-[700px] laptop:w-[550px] top-0 right-0">
            <div
                class="mobile:px-8 tablet:px-32 laptop:px-48 desktop:px-16 largeDesktop:px-28 h-screen flex flex-col items-center justify-center bg-[#2359a8f0] laptop:bg-[#2359A8]">
                <img src="../../assets/images/MyHappy-Logo.png"
                    class="w-[210px] tablet:w-[265px] object-cover mb-[20px] largeDesktop:mb-[70px]" alt="fyxify Logo">
                <div class="w-full">
                    <h2
                        class="text-center font-roboto text-2xl tablet:text-3xl largeDesktop:text-[40px] font-medium mobile:my-3 tablet:my-[15px] largeDesktop:my-[30px] text-white">
                        Reset Password</h2>
                    <div
                        class="grid w-full tablet:max-w-[450px] mobile:gap-2 tablet:gap-4 largeDesktop:gap-5 mt-[15px] largeDesktop:mt-[50px] mx-auto">
                        <div class="form-group">
                            <label for="password" class="text-base font-roboto  mb-1 text-white">New Password:</label>
                            <div class="relative">
                                <inputComponent v-model="password" ref="passwordRef" name="password" type="password"
                                    required :regex="$constants.PASSWORD_REGEX" errorClass="!text-customYellow-100"
                                    error-message="Minimum 8 characters with uppercase, number & symbol"
                                    placeholder="Enter Password"
                                    customClass="!text-[16px] mobile:!p-[9px] largeDesktop:!p-[11px] !rounded-[5px]" />
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="password" class="text-base font-roboto  mb-1 text-white">Confirm New
                                Password:</label>
                            <div class="relative">
                                <inputComponent v-model="confirmPassword" ref="confirmPasswordRef"
                                    name="confirmPassword" type="password" required :confirmWith="password"
                                    errorClass="!text-customYellow-100" placeholder="Enter Confirm Password"
                                    error-message="Passwords do not match"
                                    customClass="!text-[16px] mobile:!p-[9px] largeDesktop:!p-[11px] !rounded-[5px]" />
                            </div>
                        </div>
                    </div>
                    <div class="flex justify-center gap-3 mt-[20px] largeDesktop:mt-[70px]">
                        <button
                            class="px-10 py-2 font-roboto font-bold text-base tablet:text-lg uppercase rounded-full border-[1px] transition duration-300 border-customYellow-100 text-customYellow-100 hover:bg-customYellow-100 hover:text-black-100 focus:outline-none"
                            @click="backClicked">Cancel</button>
                        <button
                            class="px-10 py-2 font-roboto font-bold text-base tablet:text-lg uppercase rounded-full border-[1px] text-black-100 bg-customYellow-100 hover:bg-[#FABC4F] transition-all duration-300 cursor-pointer border-customYellow-100 focus:outline-none"
                            @click="submitNewPassword">Submit</button>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import inputComponent from '../../components/partialComponent/inputComponent.vue';
import { useToast } from "vue-toastification";
import { mapActions, mapGetters } from "vuex";
const toast = useToast();
export default {
    components: {
        inputComponent,
    },
    data() {
        return {
            step: 1,
            email: '',
            otp: '',
            password: '',
            confirmPassword: '',
            showPassword: false,
            timer: 30,
            interval: null,
        }
    },
    computed: {
        ...mapGetters([
            "passwordResetResponse"
        ]),
    },

    watch: {
        passwordResetResponse: function (data) {
            toast.success(this.passwordResetResponse.message);
            this.$router.replace({path:'/login'})
        },
    },

    mounted() {


    },
    unmounted() {

    },

    methods: {
        ...mapActions([
            "requestPasswordReset"
        ]),


        backClicked() {
            this.$router.go(-1)
        },

        submitNewPassword() {
            let passwordRef = this.$refs.passwordRef
            let confirmPasswordRef = this.$refs.confirmPasswordRef

            if (passwordRef?.validate?.() || confirmPasswordRef?.validate?.()) {
                return
            }

            this.requestPasswordReset(
                {
                    "token": this.$route.query.token,
                    "email": this.$route.query.email,
                    "password": this.password,
                    "password_confirmation": this.confirmPassword
                })
        },
    }

};
</script>
